import {
  useEffect,
  useState
} from "react";

function PaiementForm({
  sejourId,
  montantInitial,
  montantVerrouille = false,
  facture = null,
  onClose
}) {

  const [montant, setMontant] =
    useState("");

  const [mode, setMode] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const factureSoldee =
    facture &&
    Number(facture.reste_a_payer) <= 0;

  const token =
    localStorage.getItem(
      "accessToken"
    );

  // =====================
  // INIT
  // =====================

  useEffect(() => {

    if (
      montantInitial !==
        undefined &&
      montantInitial !== null
    ) {

      const val =
        Number(
          montantInitial
        );

      if (
        !isNaN(val) &&
        val > 0
      ) {

        setMontant(val);

      }
    }

  }, [montantInitial]);

  // =====================
  // SUBMIT
  // =====================

  const handleSubmit =
    async () => {

      if (
        !montant ||
        Number(
          montant
        ) <= 0
      ) {

        alert(
          "Montant invalide"
        );

        return;
      }

      if (!mode) {

        alert(
          "Mode de paiement requis"
        );

        return;
      }

      if (
        !window.confirm(
          "Confirmer paiement ?"
        )
      ) {
        return;
      }

      setLoading(true);

      try {

        const res =
          await fetch(
            "/api/paiements",
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json",

                Authorization:
                  "Bearer " +
                  token
              },

              body: JSON.stringify(
                {
                  sejour_id:
                    sejourId,

                  montant:
                    Number(
                      montant
                    ),

                  mode_paiement:
                    mode
                }
              )
            }
          );

        const data =
          await res.json();

        if (!res.ok) {

          alert(
            data.error ||
              "Erreur paiement"
          );

          setLoading(false);

          return;
        }

        alert(
          "Paiement effectué"
        );

        onClose();

      } catch (err) {

        console.error(err);

        alert(
          "Erreur serveur"
        );

      }

      setLoading(false);
    };

  // =====================
  // RENDER
  // =====================

  return (
    <div className="bg-white rounded-2xl p-4 md:p-6 w-full max-w-md shadow-xl">

      <h3 className="text-xl md:text-2xl font-semibold mb-5">
        💳 Paiement de la facture
      </h3>

      {facture && (

          <div className="mb-5 rounded-xl border bg-gray-50 p-4">

              <h4 className="font-semibold text-gray-800 mb-3">
                  🧾 Facture
              </h4>

              <div className="space-y-2 text-sm">

                  <div className="flex justify-between">

                      <span>N°</span>

                      <span className="font-medium">
                          {facture.numero}
                      </span>

                  </div>

                  <div className="flex justify-between">

                      <span>Montant total</span>

                      <span className="font-medium">
                          {Number(
                              facture.montant_total
                          ).toLocaleString("fr-FR")} USD
                      </span>

                  </div>

                  <div className="flex justify-between">

                      <span>Déjà payé</span>

                      <span className="text-green-600 font-medium">
                          {Number(
                              facture.montant_paye
                          ).toLocaleString("fr-FR")} USD
                      </span>

                  </div>

                  <div className="flex justify-between border-t pt-2">

                      <span className="font-semibold">
                          Reste à payer
                      </span>

                      <span className="font-bold text-red-600">
                          {Number(
                              facture.reste_a_payer
                          ).toLocaleString("fr-FR")} USD
                      </span>

                      {factureSoldee && (

                          <div className="mt-4 flex justify-center">

                              <span className="px-3 py-1 rounded-full bg-green-100 text-green-700 font-semibold text-sm">

                                ✅ Facture soldée

                              </span>

                          </div>

                    )}

                  </div>

              </div>

          </div>

      )}

      <div className="space-y-4">

        {/* MONTANT */}
        <div>

          <label className="block text-sm text-gray-600 mb-2">
            Montant
          </label>

          <input
            value={montant}
            disabled={
              montantVerrouille
            }
            onChange={(e) =>
              !montantVerrouille &&
              setMontant(
                e.target.value
              )
            }
            placeholder="Montant"
            type="number"
            className={`w-full border px-4 py-3 rounded-xl outline-none focus:ring-2 focus:ring-blue-400 ${
              montantVerrouille
                ? "bg-gray-100 text-gray-500"
                : ""
            }`}
          />

        </div>

        {/* MODE */}
        <div>

          <label className="block text-sm text-gray-600 mb-2">
            Mode de paiement
          </label>

          <select
            value={mode}
            onChange={(e) =>
              setMode(
                e.target.value
              )
            }
            className="w-full border px-4 py-3 rounded-xl outline-none focus:ring-2 focus:ring-blue-400"
          >

            <option value="">
              Sélectionner
            </option>

            <option value="cash">
              Cash
            </option>

            <option value="mobile money">
              Mobile Money
            </option>

            <option value="carte">
              Carte bancaire
            </option>

            <option value="virement">
              Virement
            </option>

          </select>

        </div>

        {/* ACTIONS */}
        <div className="flex flex-col md:flex-row gap-3 pt-2">

          <button
              onClick={handleSubmit}
              disabled={loading || factureSoldee}
              className="flex-1 bg-green-600 hover:bg-green-700 transition text-white py-3 rounded-xl disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {
                loading
                    ? "Traitement..."
                    : factureSoldee
                        ? "Facture soldée"
                        : "Valider le paiement"
            }

          </button>

          <button
            onClick={onClose}
            className="flex-1 bg-gray-500 hover:bg-gray-600 transition text-white py-3 rounded-xl"
          >
            Annuler
          </button>

        </div>

      </div>

    </div>
  );
}

export default PaiementForm;